import React, { useState, useEffect } from "react";
import { getAllPhysician } from "../../../store/slices/physicianSlice";
import { useSelector, useDispatch } from "react-redux";
import Table from "../../common/Table/table";
import { useNavigate } from "react-router-dom";

const PhysicianPayment = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { clinicInfo } = useSelector((state) => state.clinic);
  const { token } = useSelector((state) => state.auth);
  const { physician,searchMessage,loading } = useSelector((state) => state.physician);
  const [searchValue, setSearchValue] = useState("");
  const clinicId =  clinicInfo?.[0]?.clinicId ||null;
  useEffect(() => {
    dispatch(
      getAllPhysician({
        clinicId,
        clinicStatus: "Accepted",
        physicianStatus: "Accepted",
        token,
      })
    );
  }, [dispatch, clinicId, token]);

  const tableHead = [
    { title: "Physician Name", key: "name" },
    { title: "Specialization", key: "specialization" },
    { title: "Action", key: "action" },
  ];

  const handleSearch = async (e) => {
    const value = e.target.value;
    setSearchValue(value);
    await dispatch(
      getAllPhysician({
        searchQuery: value,
        clinicId,
        clinicStatus: "Accepted",
        physicianStatus: "Accepted",
        token,
      })
    );
  };

  const redirectpage = (item) => {
    sessionStorage.setItem("physicianName", item?.userId?.name || "NA");
    navigate("/physicianPaymentHistory", { state: { physicianId: item._id } }); 

  };
  

  return (
    <div className="container mt-4">
      <Table
        tableHead={tableHead}
        tableBody={
          physician?.map((item) => ({
            id: item?._id || "NA",
            name: item?.userId?.name || "NA",
            specialization: item?.specialization?.[0]?.specialization || "NA",
            action: (
              <button
                className="btn btn-primary"
                onClick={() => redirectpage(item)}
              >
                Payment History
              </button>
            ),
          })) || []
        }
        handleSearch={handleSearch}
        errorMessage={searchMessage}
        isLoading={loading}
      />
    </div>
  );
};

export default PhysicianPayment;
